import { Component } from "@angular/core";
import { NavController, NavParams, ViewController } from "ionic-angular";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { DemoProvider } from "../../providers/demo/demo";
import { StarmsClientProvider } from "../../providers/starms-client/starms-client";
import { TimeProvider } from "../../providers/time/time";
import { ApplicationApiProvider } from "../../providers/application-api/application-api";

import Enumerable from "linq";
import { InAppBrowser } from "@ionic-native/in-app-browser";

@Component({
  selector: "page-notifications-details",
  templateUrl: "notifications-details.html",
})
export class NotificationsDetailsPage {
  addNotificationCommentForm: FormGroup;
  notification: any;
  comments: Array<any> = [];
  constructor(
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    public navParams: NavParams,
    private fb: FormBuilder,
    private demo: DemoProvider,
    private starms: StarmsClientProvider,
    private time: TimeProvider,
    private inAppBrowser: InAppBrowser,
    private appApi: ApplicationApiProvider
  ) {
    // Set up the form
    this.addNotificationCommentForm = this.fb.group({
      comment: ["", Validators.required],
    });
  }

  ionViewDidLoad(): void {
    this.notification = this.navParams.data;
    this.getComments();
  }

  /**
   * Post a comment for the current notification
   */
  postComment(): void {
    if (this.demo.demoMode) {
      this.appApi.showToast("Comments are disabled in demo mode");
    } else {
      if (this.addNotificationCommentForm.valid) {
        let data = {
          Text: this.addNotificationCommentForm.value.comment,
          TypeId: this.notification.notificationFileId,
          Title: "RE: " + this.notification.subject,
          Date: this.time.get(),
        };
        this.starms.post(["comments/notifications"], undefined, data).subscribe(
          () => {
            this.getComments();
            this.appApi.showToast("The comment has been added");
            this.addNotificationCommentForm.reset();
          },
          () => {
            this.appApi.showToast(
              "Something went wrong, please try again later."
            );
          }
        );
      } else {
        this.appApi.showToast("Invalid input");
      }
    }
  }

  /**
   * Get all comments
   */
  getComments(): void {
    this.starms
      .get(["comments/notifications", this.notification.notificationFileId], {
        from: "2016-01-01",
        to: this.time.get(),
      })
      .subscribe(
        (comments) => {
          this.comments = Enumerable.from(comments)
            .orderByDescending((x) => x["creationDate"])
            .toArray();
        },
        (error) => {
          console.log(error);
        }
      );
  }

  /**
   * Archive the currrent notification
   */
  archiveNotification(): void {
    if (this.demo.demoMode) {
      this.appApi.showToast("This action is disabled in demo mode");
    } else {
      this.starms
        .put(["notificationdocuments/archive"], { archived: true })
        .subscribe(
          () => {
            this.appApi.showToast("Notification has been archived");
          },
          (error) => {
            console.log(error);
          }
        );
    }
  }

  /**
   * Download the notification docuemnts
   */
  downloadDocuments(notificationFileName: string): void {
    if (this.demo.demoMode) {
      this.inAppBrowser.create(
        "https://sta-rms.siemens-energy.com/myhealth/assets/redirect.html?redirect=" +
          "myhealth/assets/demo-data/" +
          notificationFileName,
        "_system",
        "clearcache=yes"
      );
    } else {
      this.inAppBrowser.create(
        `https://sta-rms.siemens-energy.com/myhealth/assets/redirect.html?redirect=${(
          this.notification.url as string
        ).slice(1, this.notification.url.length)}`,
        // report.getDownloadUrl().substring(1, report.getDownloadUrl().length),
        "_system",
        "location=yes"
      );
    }
  }

  /**
   * Close the current page
   */
  dismiss(): void {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/notifications-details/notifications-details.ts